import {ShieldCheck, CheckCircle2} from 'lucide-react';
import { motion } from "framer-motion";

const BONUS_LOGO = "https://static.lumi.new/material/fd/fde2ed2e2018fe80ffa47b0c2e0eff1c.png";

export default function HeroSectionBonus() {
  return (
    <section className="relative bg-blue-900 pt-20 md:pt-24 pb-12 md:pb-20 overflow-hidden">
      {/* Bandeiras sutis nos cantos */}
      <div className="absolute top-20 left-4 md:left-12 opacity-10 text-6xl md:text-8xl select-none pointer-events-none animate-float">
        &#127482;&#127480;
      </div>
      <div className="absolute top-28 right-4 md:right-12 opacity-10 text-5xl md:text-7xl select-none pointer-events-none animate-float" style={{ animationDelay: "1.5s" }}>
        &#127468;&#127463;
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center">

          {/* Logo Vale Bonus */}
          <div className="flex justify-start mb-6">
            <img
              src={BONUS_LOGO}
              alt="Vale Bônus"
              className="h-[28.8px] md:h-[40.32px] w-auto object-contain drop-shadow-lg rounded-md"></img>

          </div>

          <h1 className="font-serif sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 text-4xl pt-[20px] pl-[15px] pr-[15px] pb-[20px]">Pare de começar inglês do zero todo ano.

          </h1>
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6 pl-[30px] pr-[30px]">
            Saia do básico em 6 meses{" "}
            <span className="text-yellow-400">ou seu dinheiro de volta.</span>
          </h2>
          <p className="text-blue-200 text-lg md:text-xl max-w-2xl mx-auto mb-8 leading-relaxed">
            Você não precisa de mais um curso.{" "}
            <span className="font-semibold text-white">
              Precisa de estrutura, prática e acompanhamento certo.
            </span>
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-10 mb-8">

          <div className="flex flex-col items-center gap-4">
            <a
              href="#cta-final"
              onClick={(e) => {e.preventDefault();document.getElementById('cta-final')?.scrollIntoView({ behavior: 'smooth' });}}
              className="cta-button inline-flex items-center gap-2 bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold md:text-xl md:px-12 md:py-5 rounded-xl shadow-lg shadow-yellow-400/30 hover:shadow-yellow-400/50 transition-all duration-300 hover:scale-105 animate-pulse-glow pt-[16px] pl-[8px] pr-[8px] pb-[10px] cursor-pointer">

              <span className="text-2xl">👉</span> Quero sair do básico em 6 meses
            </a>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 text-sm text-blue-200">
              <span className="flex items-center gap-1.5 text-base">
                <CheckCircle2 className="w-4 h-4 text-yellow-400" />
                Garantia incondicional de evolução
              </span>
              <span className="flex items-center gap-1.5 text-base">
                <CheckCircle2 className="w-4 h-4 text-yellow-400" />
                Acesso completo a todos os recursos
              </span>
              <span className="flex items-center gap-1.5 text-base">
                <CheckCircle2 className="w-4 h-4 text-yellow-400" />
                Estrutura validada por mais de 10.000 alunos
              </span>
            </div>
          </div>

          {/* Selo de garantia */}
          <div className="flex-shrink-0">
            <div className="relative w-36 h-36 md:w-44 md:h-44">
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 rounded-full shadow-xl flex items-center justify-center p-1">
                <div className="bg-white rounded-full w-full h-full flex flex-col items-center justify-center p-3 text-center">
                  <ShieldCheck className="w-8 h-8 text-green-600 mb-1" />
                  <p className="text-xs md:text-sm font-bold text-blue-900 leading-tight">
                    Saia do básico em 6 meses
                  </p>
                  <p className="text-[10px] md:text-xs text-red-600 font-semibold mt-0.5">
                    ou seu dinheiro de volta
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>);
}